import React, { useState } from 'react'
import Button from 'components/Button'

interface DiscountProps {
  isValid?: boolean
  value?: string
  setValue: (value: string) => void
}

const Discount: React.FC<DiscountProps> = ({ isValid, value, setValue }) => {
  const [discount, setDiscount] = useState(value || '')
  return (
    <div className='order__discount myInput'>
      <label className={isValid ? 'form__valid' : isValid === false ? 'form__error' : undefined}>
        Wpisz kod rabatowy{typeof isValid === 'boolean' ? ` - kod ${isValid ? 'poprawny' : 'niepoprawny'}` : ''}
      </label>
      <div>
        <input
          type='text'
          className={isValid ? 'form__valid' : isValid === false ? 'error' : undefined}
          value={discount}
          onChange={e => {
            setDiscount(e.target.value)
          }}
        />
        {value !== discount && <Button
          type='primary'
          text='Zastosuj'
          action={() => {
            setValue(discount)
          }}
        />}
        <button
          className='btn btn--secondary'
          onClick={() => {
            setDiscount('')
            setValue('')
          }}>
          <i className='icon icon--close' />
        </button>
      </div>
    </div>
  )
}

export default Discount